import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import JsonLd from '@/components/base/JsonLd';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import FeaturedVideos from './components/FeaturedVideos';
import LatestUpdates from './components/LatestUpdates';
import { siteInfo } from '@/mocks/siteInfo';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: `${siteInfo.url}/search?q={search_term_string}`,
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: siteInfo.name,
  url: siteInfo.url,
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: siteInfo.address,
    addressLocality: '北京',
    addressRegion: '北京',
    addressCountry: 'CN',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="91视频网站 - 91视频免费在线观看 | 91在线视频网站"
        description="91视频网站提供海量视频免费在线观看，涵盖91视频、91在线视频、91免费在线视频等，高清流畅不卡顿，电影电视剧综艺每日更新。"
        keywords="91视频,91在线视频,91免费在线视频,91免费视频网站,91视频免费,91视频在线观看,91视频播放,91福利在线视频,91视频app,91视频官网"
        canonicalUrl={siteInfo.url}
        ogTitle="91视频网站 - 海量视频免费在线观看"
        ogDescription="91视频网站提供海量视频免费在线观看，涵盖电影、电视剧、综艺、动漫、纪录片等，高清流畅不卡顿，每日更新。"
      />

      <JsonLd data={websiteSchema} />
      <JsonLd data={orgSchema} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategorySection />
          <FeaturedVideos />
          <LatestUpdates />

          <section className="py-14 md:py-20 bg-background-50">
            <div className="w-full px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-4">
                为什么选择91视频？
              </h2>
              <p className="text-sm text-foreground-500 mb-12 max-w-2xl mx-auto">
                我们致力于为用户提供最优质的在线视频观看体验
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                <div className="p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-hd-line text-primary-500 text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">超清画质</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">支持1080P及4K超清播放，带来沉浸式观影享受</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 rounded-lg bg-accent-100 flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-speed-up-line text-accent-500 text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">流畅播放</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">全球CDN加速节点，极速加载不卡顿，即点即播</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-refresh-line text-secondary-500 text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">每日更新</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">全天候内容更新，最新电影电视剧综艺第一时间上线</p>
                </div>
                <div className="p-6 rounded-xl bg-background-100">
                  <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 mx-auto">
                    <i className="ri-device-line text-primary-500 text-xl"></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 font-heading">多端同步</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">电脑、手机、平板全平台支持，观影记录云端同步</p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-primary-500">
            <div className="w-full px-4 md:px-6 text-center">
              <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-4">
                立即开始你的观影之旅
              </h2>
              <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto">
                加入8000万用户的行列，畅享海量高清视频内容，精彩不间断
              </p>
              <a
                href="/category/dianying"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                免费观看
              </a>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}